/**
 * A tool-name chip: hairline and mono (the one place the task map keeps
 * the code font, because tool names come from the code).
 */

export function ToolChip({ name }: { name: string }): React.JSX.Element {
  return (
    <span className="inline-block rounded-sm border border-border px-1.5 py-0.5 font-mono text-[11px] text-foreground">
      {name}
    </span>
  )
}
